import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const RadioSvg = /* @__PURE__ */ __name(() => /* @__PURE__ */ React.createElement("svg", {
  className: "mds-switch-icon-radio",
  fill: "none",
  viewBox: "0 0 20 20"
}, /* @__PURE__ */ React.createElement("circle", {
  cx: "10",
  cy: "10",
  fill: "white",
  r: "9",
  stroke: "var(--mds-switch-icon-outer)",
  strokeWidth: "2"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "10",
  cy: "10",
  fill: "var(--mds-switch-icon-inner)",
  r: "5"
})), "RadioSvg");

export { RadioSvg };
//# sourceMappingURL=radio-svg.js.map
